import {PhoneModel} from "../entity/phone.model";

export class PhoneSavePayload {
    dialingCode: string;
    number: number;

    static fromPhoneModel(phone: PhoneModel) {
        return phone ? {
            dialingCode: phone.dialingCode,
            number: phone.number
        } : undefined;
    }
}
